import { useEffect, useRef } from 'react';
import { useAppSelector } from '../../../../hooks';
import { useCustomNavigate } from '../../../../hooks/useCustomNavigate';
import { selectCardDepositBePaidGatewayUrl } from '../../../../services/deposit';
import { ROUTES } from '../../../../types/routes';
import { mapClassnameForMobile } from '../../../../utils';
import { HeaderLayout } from '../../../common/header';

const CardBePaidLayout = () => {
	const bePaidGatewayUrl = useAppSelector(selectCardDepositBePaidGatewayUrl);

	const iframeRef = useRef(null);
	const navigate = useCustomNavigate();

	useEffect(() => {
		if(bePaidGatewayUrl === '') {
            handleBackClick()
        }
	}, []);

	const handleBackClick = () => {
		navigate(ROUTES.DEPOSIT.CARD.INDEX);
	};

	return (
		<div className={'component'}>
			<div
				style={{
					overflow: 'hidden',
				}}
				className={'innerComponent'}
			>
				<HeaderLayout isFunctionalHeader handleBackClick={handleBackClick} />
				<div
					style={{
						height: '100%',
						boxSizing: 'border-box',
						padding: '0 24px',
					}}
					className={mapClassnameForMobile('walletLayout')}
				>
					<iframe
						style={{
							height: '100%',
							width: '100%',
                            border: '0'
						}}
						src={bePaidGatewayUrl}
						ref={iframeRef}
					/>
				</div>
			</div>
		</div>
	);
};

export default CardBePaidLayout;
